import { createContext, useState } from "react"
import API from "services/api"
import _ from "lodash"
import toast from "react-hot-toast"

export const HistoryContext = createContext({})

const HistoryProvider = (props) => {
	const [histories, setHistories] = useState([])

	const getHistory = (params) => {
		return API.getHistory(params)
			.then((res) => {
				const data = res.data
				setHistories(data)
				return data
			})
			.catch((err) => {
				console.log("err", err)
				return err
			})
	}

	const getHistorybyRefID = (id) => {
		return API.getHistorybyRefID(id)
			.then((res) => {
				const data = res.data
				setHistories(data)
				return data
			})
			.catch((err) => {
				console.log("err", err)
				return err
			})
	}

	const postHistory = (sendData) => {
		return API.postHistory(sendData)
			.then((res) => {
				const { data } = res
				return data
			})
			.catch((err) => {
				return err
			})
	}

	const putHistory = (id, sendData) => {
		return API.putHistory(id, sendData)
			.then((res) => {
				const { data } = res
				return data
			})
			.catch((err) => {
				return err
			})
	}

	const deleteHistory = (id) => {
		return API.deleteHistory(id)
			.then((res) => {
				return res
			})
			.catch((err) => {
				return err
			})
	}

	return (
		<HistoryContext.Provider
			value={{
				histories,
				getHistory,
				postHistory,
				putHistory,
				deleteHistory,

				getHistorybyRefID
			}}
			{...props}
		/>
	)
}

export default HistoryProvider
